export default "__VITE_ASSET__ok1Z3u3Z__"